import { useMemo, useState } from 'react'

import { useFilters, useModals, useSetState } from '@domain-group/react-hooks'
import type { UseFiltersPayload } from '@domain-group/react-hooks'

import { MainContent, ModalContext, TopBar } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import useMainNavigation from '@hooks/useMainNavigation'

import DashboardSearch from '@components/DashboardSearch'
import LoggedInUser from '@components/LoggedInUser'
import MainNavigation from '@sections/Admin/components/MainNavigation'

import PageContent from './components/PageContent'
import { AssignTemplatePagePermissionsModalPayload } from '@modals/AssignTemplatePagePermissionsModal/AssignTemplatePagePermissionsModal'

export type PageContextPayload = UseFiltersPayload & {
  callbacks: {
    showLinkTemplatesModal: () => void,
  },
}

const defaultState = {
  showLinkTemplatesModal: false,
}

type SetState = (state: Partial<typeof defaultState>) => void

const List = () => {
  const [state, setState] = useSetState(defaultState)
  const { showLinkTemplatesModal } = state

  const { callbacks: { toggleNavigation } } = useMainNavigation()

  const filtersPayload = useFilters({
    defaultFilters: { builder: 'canva' },
    persistFilters: true,
  })
  const {
    callbacks: filterCallbacks,
    defaultFilters,
    defaultFiltersModifiedAt,
    pageFilters,
  } = filtersPayload
  const [assignTemplatePagePermissionsPayload, setAssignTemplatePagePermissionsPayload] = useState<
      AssignTemplatePagePermissionsModalPayload | null
    >(null)
  const modalContext = useModals()

  const pageContext = useMemo(() => ({
    callbacks: {
      ...filterCallbacks,
      showLinkTemplatesModal: () => {
        setState({ showLinkTemplatesModal: true })
      },
      showAssignTemplatePagePermissionsModal: (payload: AssignTemplatePagePermissionsModalPayload) => {
              setAssignTemplatePagePermissionsPayload(payload)
            }
    },
    defaultFilters,
  }), [defaultFiltersModifiedAt])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <TopBar
          callbacks={{ toggleNavigation }}
          loggedInUserComponent={<LoggedInUser />}
          searchComponent={<DashboardSearch searchEntities={['LayoutTemplate', 'TaskList', 'TemplatePage', 'TemplatePagePartial']} />}
        />

        {/*
         // @ts-expect-error TS2739 */}
        <MainNavigation />

        <MainContent offset={{ top: TopBar.topBarHeight }}>
          {!showLinkTemplatesModal && <PageContent assignTemplatePagePermissionsPayload={assignTemplatePagePermissionsPayload} setAssignTemplatePagePermissionsPayload= {setAssignTemplatePagePermissionsPayload} pageFilters={pageFilters} />}
        </MainContent>
      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default List
